import { render, staticRenderFns } from "./SubTabs.vue?vue&type=template&id=5deaf572&scoped=true"
import script from "./SubTabs.vue?vue&type=script&lang=js"
export * from "./SubTabs.vue?vue&type=script&lang=js"
import style0 from "./SubTabs.vue?vue&type=style&index=0&id=5deaf572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deaf572",
  null
  
)

export default component.exports